import React from "react";
import NDAInformation from "./NDAInformation";

function Index() {
  return <NDAInformation />;
}

export default Index;
